import type { PriceStrategy } from '@snap-types/models/enums';
import { priceStrategyUIConfig } from '@ui/config/price';
import type { QuotePriceField } from '@ui/config/price/constants';

export function isEditableQuotePriceField(
  strategy: PriceStrategy,
  field: QuotePriceField,
) {
  const uiConfig = priceStrategyUIConfig[strategy];
  const fieldConfig = uiConfig.fields.find((f) => f.field === field);

  if (!fieldConfig) {
    throw new Error(
      `Price strategy ${strategy} does not have a ${field} field in its UI config`,
    );
  }

  return fieldConfig.editable;
}
